import { BaseMutations } from '@/store/base-mutations';
import {
  CatalogView,
  Characteristic,
  ProdQtyUpdateDTO,
  Products,
  ProductsFilters,
  AddProductDialog,
  CategoriesSlug,
  SoftwareTypesInterface,
  CatalogRequestFilters,
} from '../types';
import ProductState from './state';
import { default_catalog_filters, default_filters } from '../services';

export default class ProductMutations extends BaseMutations<ProductState> {
  SET_PRODUCTS(prods: Products.Product[]) {
    this.state.products = prods;
  }

  SET_CATALOG(catalog_products: Products.CatalogProductItem[]) {
    this.state.catalog_products = catalog_products;
  }

  UPD_PRODUCTS_SELECT({ item, value }: { item: Products.Product, value: boolean }) {
    if (!value) {
      this.state.products = this.state.products.map((p) => {
        if (p.id === item.id) {
          // eslint-disable-next-line no-param-reassign
          p.selected = true;
        }
        return p;
      });
    } else {
      this.state.products = this.state.products.map((p) => {
        if (p.id === item.id) {
          // eslint-disable-next-line no-param-reassign
          p.selected = false;
        }
        return p;
      });
    }
  }

  UPD_CATALOG_SELECT({ item, value }: { item: Products.CatalogProductItem, value: boolean }) {
    this.state.catalog_products = this.state.catalog_products.map((p) => {
      if (p.id === item.id) {
        // eslint-disable-next-line no-param-reassign
        p.selected = !value;
      }
      return p;
    });
  }

  UPD_PRODUCTS_SELECT_ALL(value: boolean) {
    if (value) {
      this.state.products = this.state.products.map((p) => ({
        ...p,
        selected: true,
      }));
    } else {
      this.state.products = this.state.products.map((p) => ({
        ...p,
        selected: false,
      }));
    }
  }

  UPD_CATALOG_SELECT_ALL(value: boolean) {
    this.state.catalog_products = this.state.catalog_products.map((p) => ({
      ...p,
      selected: value,
    }));
  }

  UPD_PRODUCT_QTY(prod: ProdQtyUpdateDTO | ProdQtyUpdateDTO[]) {
    const get_idx = (id: number | string) => this.state.products.findIndex((e) => e.id === id);

    if (Array.isArray(prod)) {
      prod.forEach((item) => {
        const i = get_idx(item.id);

        if (i >= 0) {
          this.state.products[i].quantity = item.quantity;
        }
      });
    } else {
      const idx = get_idx(prod.id);

      if (idx >= 0) {
        this.state.products[idx].quantity = prod.quantity;
      }
    }
  }

  UPD_CATALOG_PRODUCT_QTY(product: ProdQtyUpdateDTO | ProdQtyUpdateDTO[]) {
    const get_idx = (id: number | string) => this.state.catalog_products.findIndex((e) => e.id === id);

    if (Array.isArray(product)) {
      product.forEach((item) => {
        const i = get_idx(item.id);

        if (i >= 0) {
          this.state.catalog_products[i].quantity = item.quantity;
        }
      });
    } else {
      const idx = get_idx(product.id);

      if (idx >= 0) {
        this.state.catalog_products[idx].quantity = product.quantity;
      }
    }
  }

  SET_CURRENT_PRODUCT(prod: Products.Product | null) {
    const payload = prod;

    if (payload && !payload?.quantity) {
      payload.quantity = 0;
    }

    this.state.current_product = payload;
  }

  UPD_CURRENT_PRODUCT(prod: Products.Product) {
    this.state.current_product = prod;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof ProductsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  UPD_CATALOG_FILTER_KEY({ key, value }: { key: keyof CatalogRequestFilters, value: unknown }) {
    this.state.catalog_filters[key] = value;
  }

  SET_FILTERS(filters: ProductsFilters) {
    this.state.filters = filters;
  }

  UPD_CATALOG_VIEW(view: CatalogView) {
    this.state.catalog_view = view;
  }

  SET_CHARS_PROD(chars: Characteristic[]) {
    this.state.characteristics = chars;
  }

  SET_CATEGORIES(cats: CategoriesSlug[]) {
    this.state.categories = cats;
  }

  SET_CATALOG_CATEGORIES(categories: Products.CategoryFilterItem[]) {
    this.state.catalog_categories = categories;
  }

  SET_SOFTWARE_TYPES(software_types: SoftwareTypesInterface[]) {
    this.state.software_types = software_types;
  }

  SET_CATALOG_SOFTWARE_TYPES(software_types: Products.CatalogFilterItem[]) {
    this.state.catalog_software_types = software_types;
  }

  SET_CATALOG_EQUIPMENT_MODELS(equipment_models: Products.EquipmentModelFilterItem[]) {
    this.state.catalog_equipment_models = equipment_models;
  }

  SET_HAS_REALIZATION_CONTRACT(value: boolean) {
    this.state.has_realization_contract = value;
  }

  SET_PRICES_TYPES(data: string[]) {
    this.state.prices_types.items = data;
  }

  SET_LICENSE_KEY(license_key: string) {
    this.state.license_key = license_key;
  }

  SET_LICENSE_KEY_ARR({ license_key, prd }: { license_key: string, prd: Products.Product }) {
    const lcs = {
      id: prd.id,
      license_key,
    };

    if (this.state.license_key_arr.length === 0) {
      this.state.license_key_arr.push(lcs);
    } else {
      let isNotInArr = false;

      this.state.license_key_arr = this.state.license_key_arr.map((k) => {
        if (k.id === lcs.id) {
          k.license_key = lcs.license_key;
          isNotInArr = false;
        } else {
          isNotInArr = true;
        }
        return k;
      });

      if (isNotInArr) {
        this.state.license_key_arr.push(lcs);
      }
    }
  }

  SET_LICENSE_KEY_ARR1({ license_key, prd }: { license_key: string, prd: Products.RelatedProduct }) {
    const lcs = {
      id: prd.id,
      license_key,
    };

    if (this.state.license_key_arr.length === 0) {
      this.state.license_key_arr.push(lcs);
    } else {
      let isNotInArr = false;

      this.state.license_key_arr = this.state.license_key_arr.map((k) => {
        if (k.id === lcs.id) {
          k.license_key = lcs.license_key;
          isNotInArr = false;
        } else {
          isNotInArr = true;
        }
        return k;
      });

      if (isNotInArr) {
        this.state.license_key_arr.push(lcs);
      }
    }
  }

  CLEAR_SEARCH() {
    this.state.search_key = '';
  }

  SET_CURRENT_LICENSE_KEYS(items: string[]) {
    this.state.current_select_keys = items;
  }

  SET_SEARCH_SELECT_KEY(value: string) {
    this.state.search_key = value;
  }

  UPD_ADD_PRODUCT_DIALOG({ key, value }: { key: keyof AddProductDialog, value: unknown }) {
    this.state.add_product_dialog[key] = value;
  }

  CLEAR_ADD_PRODUCT_DIALOG() {
    this.state.license_key = '';
    this.state.license_key_arr = [];
    this.state.add_product_dialog.visible = false;
  }

  UPD_ZIP_CAT_FILTER(value: number) {
    this.state.zip_cat_filter.push(value);
  }

  CLEAR_ZIP_CAT_FILTER() {
    this.state.zip_cat_filter = [];
  }

  SET_MODELS(models: number[]) {
    this.state.models = models;
  }

  SET_CATEGORIES_FOR_BANNER_ID(value: number[]) {
    this.state.query_categories = value;
  }

  UPD_ALL_FILTERS(new_filters: ProductsFilters) {
    this.state.filters = { ...new_filters };
  }

  UPD_ALL_CATALOG_FILTERS(new_filters: CatalogRequestFilters) {
    this.state.catalog_filters = { ...new_filters };
  }

  TOGGLE_IS_FIXED_FILTERS(value: boolean) {
    this.state.is_fixed = value;
  }

  CLEAR_IS_FIXED() {
    this.state.is_fixed = false;
  }

  UPD_IS_SHOW_ALL_PRICE(value: boolean) {
    this.state.is_show_all_price = value;
  }

  UPD_FAVORITES(value: boolean) {
    if (this.state.current_product) {
      this.state.current_product.is_favorite = value;
    }
  }

  UPD_FAVORITES_ONLY_TOGGLE(value: boolean) {
    this.state.is_favorites_only_toggle = value;
  }

  CLEAR_FILTERS() {
    this.state.filters = default_filters();
  }

  CLEAR_CATALOG_FILTERS() {
    this.state.catalog_filters = default_catalog_filters();
  }

  SET_LOADING(value: boolean) {
    this.state.loading = value;
  }

  SET_IS_NEW_CATALOG_TOGGLE(value: boolean) {
    this.state.is_new_catalog = value;
  }
}
